<template>
  <div class="enrolled-wrap">
    <div v-if="applyList.length" class="enrolled-list">
      <div class="detail-head">
        <span>序号</span>
        <span>红人</span>
        <span>合作意向</span>
        <span>意向说明</span>
        <span>备注</span>
        <span>平台</span>
        <span>状态</span>
        <span>操作</span>
      </div>
      <div v-for="(row, idx) in applyList" :key="row.id || idx" class="enrolled-row">
        <div class="row-index">{{ idx + 1 }}</div>
        <div class="row-name">
          <el-tag v-if="row.is_assign==1" type="danger" class="assign-tag">定向</el-tag>
          <span class="row-name-text">{{ row.nickname }}</span>
          <span v-if="row.group_id" class="row-group-tag">{{ row.group_name || '-' }}</span>
        </div>
        <div class="row-intention">
          <span class="intention-pill" :class="'is-' + intentionKey(row.intention)">
            {{ row.intention === 1 ? '试用' : row.intention === 2 ? '可接' : '拒接' }}
          </span>
        </div>
        <div class="row-text">{{ row.intention_note }}</div>
        <div class="row-text">{{ row.note }}</div>
        <div class="platform-tags">
          <span class="platform-chip is-selected is-link"
                title="查看关联的刊例提报记录"
                @click.stop="openPlc(row)">
            <span class="platform-check">
              <i class="el-icon-check"></i>
            </span>
            {{ row.platform_name }} - {{ row.account_id || row.journal_id }}
          </span>
          <!--          <span-->
          <!--              v-for="tag in row.platformTags"-->
          <!--              :key="tag.name"-->
          <!--              class="platform-chip is-selected"-->
          <!--              :style="{ '&#45;&#45;platform-color': tag.color }">-->
          <!--            <span class="platform-check">-->
          <!--              <i class="el-icon-check"></i>-->
          <!--            </span>-->
          <!--            {{ tag.name }}-->
          <!--          </span>-->
        </div>
        <div class="row-status">
          <span class="status-pill"
                :class="row.confirm_status === 2 ? 'is-applied' : row.employ_status === 2 ? 'is-pending' : 'is-default'">
            <span class="status-dot"></span>
            {{ row.confirm_status === 2 ? '已合作' : row.employ_status === 2 ? '已初选' : '已报名' }}
          </span>
        </div>
        <div class="row-action">
          <el-popconfirm
            v-if="infoStatus.status===1&&(row.confirm_status!==2||row.employ_status!==2)"
            :title="`确定要取消【${row.nickname}】的全部报名吗？（${row.ids?row.ids.join('|'):''} 个平台将一起取消）`"
            confirm-button-text='好的'
            @confirm="handleVoid(row)"
          >
            <el-button v-if="userPermissions.indexOf('inquiry_apply_cancel') !== -1" slot="reference"
                       type="primary"
                       size="mini"
                       icon="el-icon-circle-close">取消报名
            </el-button>
          </el-popconfirm>
        </div>
      </div>
    </div>
    <div v-else class="empty-text">暂无已报名列表</div>

    <!-- 查看关联的刊例提报记录（关联表 inquiry_plc_items） -->
    <el-dialog
      :title="plcTitle"
      :visible.sync="plcDialogVisible"
      width="860px"
      top="8vh"
      append-to-body
      class="enrolled-plc-dialog">
      <div v-if="plcChecking" class="plc-match-status is-muted">刊例匹配校验中…</div>
      <div v-else-if="plcCheck" class="plc-match-status"
           :class="plcCheck.matched ? 'is-ok' : (plcCheck.can_fix ? 'is-warn' : 'is-muted')">
        <template v-if="plcCheck.matched">
          <i class="el-icon-success"></i> 已关联最新刊例
        </template>
        <template v-else-if="plcCheck.can_fix">
          <i class="el-icon-warning"></i>
          应关联的最新刊例ID({{ (plcCheck.expected && plcCheck.expected.id) || '' }}) 与当前关联不一致
          <el-button class="plc-fix-btn" type="warning" size="mini" @click="doPlcFix(plcRow)">更换为最新刊例</el-button>
        </template>
        <template v-else>
          <i class="el-icon-info"></i> 未匹配到应关联的最新刊例（可能该账号/平台暂无报价刊例）
        </template>
      </div>
      <div v-if="plcRow" class="plc-toolbar">
        <el-button type="primary" size="mini" icon="el-icon-search" @click="openManual">手动检索 / 选择提报刊例</el-button>
        <span class="plc-toolbar-hint">仅检索 《红人平台信息》 一致的提报刊例</span>
      </div>
      <div v-if="plcRecords.length" class="plc-list">
        <div v-for="(rec, idx) in plcRecords" :key="rec.inquiry_plc_id || rec.id || idx" class="plc-card">
          <div class="plc-card-head">
            <span class="plc-index">{{ idx + 1 }}</span>
            <span class="plc-name">{{ rec.platform_name || rec.platform_code || '-' }}</span>
            <span class="plc-account">{{ rec.account_id || '-' }}</span>
            <el-tag size="mini" type="info">刊例ID: {{ rec.id || '-' }}</el-tag>
            <span class="plc-time">{{ rec.updated_at || rec.created_at || '' }}</span>
          </div>
          <div class="plc-body">
            <div class="plc-field" v-if="rec.bs_case">
              <span class="plc-label">红人昵称</span>
              <span class="plc-value">{{ rec.nickname }}
                <el-tag>{{rec.org_name||''}}</el-tag>
              </span>
            </div>
            <div class="plc-field" v-if="rec.home_page_link">
              <span class="plc-label">主页链接</span>
              <a class="plc-value is-link-text" :href="rec.home_page_link" target="_blank" rel="noopener">{{ rec.home_page_link }}</a>
            </div>
            <div class="plc-quote" v-if="quoteLines(rec).length">
              <div class="plc-label">报价</div>
              <div v-for="(line, i) in quoteLines(rec)" :key="i" class="plc-quote-line">{{ line }}</div>
            </div>

            <!--            <div class="plc-field" v-if="rec.bs_case">-->
            <!--              <span class="plc-label">商务案例</span>-->
            <!--              <span class="plc-value">{{ rec.bs_case }}</span>-->
            <!--            </div>-->

          </div>
        </div>
      </div>
      <div v-else class="empty-text">暂无关联的刊例提报记录</div>
    </el-dialog>

    <!-- 手动检索 / 选择提报刊例（多选，覆盖关联） -->
    <el-dialog
      title="手动匹配提报刊例"
      :visible.sync="manualVisible"
      width="900px"
      top="6vh"
      append-to-body>
      <div class="manual-search">
        <el-input v-model="manualKeyword" size="small" placeholder="检索：刊例ID / 年份-月份 / 平台 / 账号" clearable class="manual-input">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <span class="manual-hint" title="journal_id / artist_id / platform_code">候选范围：与该报名的红人平台信息一致的提报刊例</span>
      </div>
      <el-table
        v-loading="manualLoading"
        ref="manualTable"
        :data="filteredManualList"
        row-key="id"
        height="360"
        border
        stripe
        size="mini"
        @selection-change="handleManualSelection">
        <el-table-column type="selection" width="46" reserve-selection></el-table-column>
        <el-table-column label="刊例ID" prop="id" width="90" align="center"></el-table-column>
        <el-table-column label="组织" prop="org_name" width="90" align="center"></el-table-column>
        <el-table-column label="平台" width="100">
          <template slot-scope="{row}">{{ row.platform_name || row.platform_code || '-' }}</template>
        </el-table-column>
        <el-table-column label="档期" width="100" align="center">
          <template slot-scope="{row}">{{ row.year || '-' }}-{{ (row.month || '').toString().padStart(2, '0') }}</template>
        </el-table-column>
        <el-table-column label="账号" prop="account_id" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="报价" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="hasQuote(row)" size="mini" type="success">有报价</el-tag>
            <el-tag v-else size="mini" type="info">无报价</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="商务案例" prop="bs_case" width="220" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div v-html="row.bs_case"></div>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="150">
          <template slot-scope="{row}">{{ row.updated_at || row.created_at || '-' }}</template>
        </el-table-column>
      </el-table>
      <div class="manual-empty" v-if="!manualLoading && filteredManualList.length === 0">暂无符合前置条件的提报刊例</div>
      <div slot="footer" class="manual-footer">
        <span class="manual-count">已选 {{ (manualSelRows || []).length }} 条</span>
        <el-button size="small" @click="manualVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="manualConfirming" @click="onManualConfirm">确认匹配</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'enrolledTable',//已报名列表
  data() {
    return {
      applyList: [],
      // 查看关联刊例提报记录
      plcDialogVisible: false,
      plcRow: null,
      // 刊例匹配校验
      plcCheck: null,
      plcChecking: false,
      plcJustFixedId: null,
      // 手动检索/选择提报刊例（多选）
      manualVisible: false,
      manualList: [],
      manualLoading: false,
      manualKeyword: '',
      manualSelRows: [],
      manualConfirming: false
    }
  },
  props: {
    infoPlatforms: {
      type: Array
    },
    infoStatus: {
      type: Object
    },
    projectId: {
      type: [Number, String]
    },
    refresh: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    plcRecords() {
      return (this.plcRow && Array.isArray(this.plcRow.plc_items)) ? this.plcRow.plc_items : []
    },
    plcTitle() {
      const row = this.plcRow
      if (!row) {
        return ''
      }
      const who = row.nickname ? `${row.nickname} - ` : ''
      const platform = row.platform_name || row.platform_code || ''
      return `${who}${platform} 刊例提报记录`
    },
    filteredManualList() {
      const kw = String(this.manualKeyword || '').trim().toLowerCase()
      if (!kw) {
        return this.manualList
      }
      return this.manualList.filter((row) => {
        const period = row.year ? `${row.year}-${(row.month || '').toString().padStart(2, '0')}` : ''
        const haystack = [row.id, row.platform_code, row.platform_name, row.account_id, period]
          .filter(v => v !== undefined && v !== null && v !== '')
          .map(v => String(v).toLowerCase())
          .join(' ')
        return haystack.indexOf(kw) !== -1
      })
    }
  },

  methods: {
    openPlc(row) {
      this.plcRow = row || null
      this.plcCheck = null
      this.plcJustFixedId = null
      this.plcDialogVisible = true
      this.runPlcCheck(row)
    },
    // 打开弹窗后异步校验该记录应关联的最新刊例是否与已关联一致
    async runPlcCheck(row) {
      if (!row || !row.id) {
        return
      }
      this.plcChecking = true
      try {
        const res = await this.$api.plcMatchCheck({id: row.id})
        // 仅在当前仍处于该校验行时才使用结果，避免快速切换行导致串扰
        if (this.plcRow && this.plcRow.id === row.id) {
          this.plcCheck = res || null
          this.afterPlcCheck(row)
        }
      } catch (e) {
        this.plcCheck = null
      } finally {
        this.plcChecking = false
      }
    },
    afterPlcCheck(row) {
      console.log('afterPlcCheck',row,this.plcCheck)
      const check = this.plcCheck
      if (!check || !check.can_fix || check.matched) {
        return
      }
      // 刚由本行“更换”过则不再重复打扰
      if (this.plcJustFixedId === row.id) {
        return
      }
      const cur = (check.current_ids && check.current_ids.length) ? check.current_ids.join(',') : '空'
      const expected = (check.expected && check.expected.id) || ''
      this.$confirm(
        `当前关联的刊例ID(${cur})与规则应关联的最新刊例ID(${expected})不一致，是否更换为应关联的最新刊例？`,
        '刊例匹配校验',
        {
          confirmButtonText: '更换',
          cancelButtonText: '暂不处理',
          type: 'warning'
        }
      ).then(() => {
        this.doPlcFix(row)
      }).catch(() => {
        // 用户暂不更换
      })
    },
    async doPlcFix(row) {
      try {
        await this.$api.plcMatchFix({id: row.id})
        this.$notify.success('已更换为应关联的最新刊例')
        this.plcJustFixedId = row.id
        // 刷新已报名列表，并让弹窗展示更新后的关联刊例
        await this.getInfo()
        const fresh = (this.applyList || []).find(x => String(x.id) === String(row.id))
        if (fresh) {
          this.plcRow = fresh
          this.plcCheck = {matched: true, can_fix: true, expected: null, current_ids: []}
        }
      } catch (e) {
        this.$notify.error('更换关联刊例失败')
      }
    },
    async openManual() {
      const row = this.plcRow
      if (!row || !row.id) {
        return
      }
      this.manualVisible = true
      this.manualList = []
      this.manualSelRows = []
      this.manualKeyword = ''
      this.manualLoading = true
      try {
        const res = await this.$api.plcCandidates({id: row.id})
        this.manualList = (res && res.list) || []
        const curIds = (res && res.current_ids) || []
        this.$nextTick(() => {
          const table = this.$refs.manualTable
          if (table) {
            table.clearSelection()
            ;(curIds || []).forEach((cid) => {
              const target = this.manualList.find(r => Number(r.id) === Number(cid))
              if (target) {
                table.toggleRowSelection(target, true)
              }
            })
          }
        })
      } catch (e) {
        this.manualList = []
      } finally {
        this.manualLoading = false
      }
    },
    handleManualSelection(rows) {
      this.manualSelRows = rows || []
    },
    hasQuote(row) {
      const q = row && row.real_quote
      if (!q) {
        return false
      }
      if (typeof q === 'object') {
        return Object.keys(q).length > 0
      }
      const s = String(q).trim()
      return s !== '' && s !== '0'
    },
    async onManualConfirm() {
      const row = this.plcRow
      if (!row || !row.id) {
        return
      }
      const ids = (this.manualSelRows || []).map(r => Number(r.id)).filter(v => v)
      this.manualConfirming = true
      try {
        await this.$api.plcAssoc({id: row.id, plc_ids: ids})
        this.$notify.success('已更新关联提报刊例')
        this.manualVisible = false
        this.plcJustFixedId = row.id
        // 刷新已报名列表并回显关联，重新做刊例匹配校验
        await this.getInfo()
        const fresh = (this.applyList || []).find(x => String(x.id) === String(row.id))
        if (fresh) {
          this.plcRow = fresh
          this.plcCheck = null
          this.runPlcCheck(fresh)
        }
      } catch (e) {
        this.$notify.error('确认匹配失败')
      } finally {
        this.manualConfirming = false
      }
    },
    // 将 real_quote（对象/字符串）转成可读的报价文案行，做兜底解析避免渲染报错
    quoteLines(rec) {
      let raw = rec && rec.real_quote
      if (raw == null) {
        return []
      }
      if (typeof raw === 'string') {
        try {
          raw = JSON.parse(raw)
        } catch (e) {
          raw = null
        }
      }
      if (!raw || typeof raw !== 'object') {
        return []
      }
      const lines = []
      const collectRows = (rows) => {
        (Array.isArray(rows) ? rows : []).forEach((r) => {
          if (!r || typeof r !== 'object') {
            return
          }
          const label = r.title || r.field || r.label
          const value = r.val !== undefined && r.val !== null ? r.val : (r.value !== undefined ? r.value : '')
          if (label !== undefined || value !== '') {
            lines.push(`${label || ''}: ${value === '' ? '-' : value}`)
          }
        })
      }
      collectRows(raw.single)
      collectRows(raw.multi)
      if (raw.mixed && typeof raw.mixed === 'object') {
        Object.values(raw.mixed).forEach((m) => {
          if (m && typeof m === 'object' && m.val !== undefined) {
            const label = m.label || m.field || ''
            lines.push(`${label ? label + ': ' : ''}${typeof m.val === 'string' ? m.val.replace(/<[^>]+>/g, '') : (m.val || '')}`)
          }
        })
      }
      if (!lines.length) {
        const compact = JSON.stringify(raw)
        lines.push(compact.length > 500 ? compact.slice(0, 500) + '…' : compact)
      }
      return lines
    },
    getPlatformTags(row) {
      const raw = row.platform_name || row.platforms || ''
      const names = String(raw).split(/[,，、/]/).map(s => s.trim()).filter(Boolean)
      const byName = new Map((this.infoPlatforms || []).map(item => [item.name, item]))
      const byValue = new Map((this.infoPlatforms || []).map(item => [item.value, item]))
      return names.map((name) => {
        const platform = byName.get(name) || byValue.get(name) || {}
        return {
          name,
          color: this.getPlatformColor(platform)
        }
      })
    },
    intentionKey(intention) {
      const value = Number(intention)
      if (value === 1) {
        return 'trial'
      }
      if (value === 2) {
        return 'accept'
      }
      return 'refuse'
    },
    getPlatformColor(platform) {
      const color = platform.color || platform.color_val || platform.color_value || platform.theme_color
      if (color) {
        return color
      }
      const key = String(platform.value || platform.name || '').toLowerCase()
      const colorMap = {
        douyin: '#111827',
        tiktok: '#111827',
        xiaohongshu: '#ff2442',
        xhs: '#ff2442',
        redbook: '#ff2442',
        kuaishou: '#ff6a00',
        ks: '#ff6a00',
        weibo: '#ff8200',
        bilibili: '#00aeec',
        bilili: '#00aeec',
        b站: '#00aeec',
        shipinhao: '#07c160',
        wx_video: '#07c160',
        package: '#6b5cff',
        抖音: '#111827',
        小红书: '#ff2442',
        快手: '#ff6a00',
        微博: '#ff8200',
        视频号: '#07c160'
      }
      return colorMap[key] || '#5b5ff5'
    },
    async getInfo() {
      const {details_all_about_me} = await this.$api.applyList({
        project_id: this.projectId,
        status: this.infoStatus.status
      })
      this.applyList = details_all_about_me || []

      // const [data, kolData] = await Promise.all([
      //   this.$api.applyList({
      //     project_id: this.projectId,
      //     status: this.infoStatus.status
      //   }),
      //   this.$api.InquiryKolList({project_id: this.projectId}).catch(() => [])
      // ])
      // // 已报名接口不返回组别，从报名列表(InquiryKolList)中提取红人 -> 组别映射
      // const groupMap = this.buildGroupMap(kolData)
      // this.applyList = this.aggregateByArtist(data.details_all_about_me || [], groupMap)
      //
      // console.log(this.applyList)
      // console.log('======================================')
    },
    // buildGroupMap(kolRows) {
    //   const map = new Map()
    //   ;(Array.isArray(kolRows) ? kolRows : []).forEach((item) => {
    //     if (!item.group_name) {
    //       return
    //     }
    //     const byId = item.id !== undefined && item.id !== null && item.id !== '' ? String(item.id) : ''
    //     if (byId) {
    //       map.set(byId, item.group_name)
    //     }
    //     if (item.nickname) {
    //       map.set(`name-${item.nickname}`, item.group_name)
    //     }
    //   })
    //   return map
    // },
    // 按 artist_id 优先、nickname 兜底解析组别
    // resolveGroupName(row, groupMap) {
    //   if (!groupMap) {
    //     return ''
    //   }
    //   const byId = row.artist_id !== undefined && row.artist_id !== null && row.artist_id !== ''
    //       ? String(row.artist_id)
    //       : ''
    //   if (byId && groupMap.has(byId)) {
    //     return groupMap.get(byId)
    //   }
    //   return groupMap.get(`name-${row.nickname || ''}`) || ''
    // },
    // aggregateByArtist(rows, groupMap) {
    //   const map = new Map()
    //   rows.forEach((row) => {
    //     const artistKey = row.artist_id !== undefined && row.artist_id !== null && row.artist_id !== ''
    //         ? String(row.artist_id)
    //         : `name-${row.nickname || 'unknown'}`
    //     const groupName = this.resolveGroupName(row, groupMap)
    //     if (!map.has(artistKey)) {
    //       map.set(artistKey, {
    //         ...row,
    //         group_name: groupName,
    //         ids: row.id !== undefined && row.id !== null ? [row.id] : [],
    //         artistRows: [row],
    //         platformTags: this.getPlatformTags(row)
    //       })
    //       return
    //     }
    //     const group = map.get(artistKey)
    //     if (row.id !== undefined && row.id !== null) {
    //       group.ids.push(row.id)
    //     }
    //     group.artistRows.push(row)
    //     // 平台 tag 合并去重
    //     this.getPlatformTags(row).forEach((tag) => {
    //       if (!group.platformTags.some(t => t.name === tag.name)) {
    //         group.platformTags.push(tag)
    //       }
    //     })
    //     // 状态取更高级别：已合作 > 已初选 > 已报名
    //     if ((row.confirm_status || 0) > (group.confirm_status || 0)) {
    //       group.confirm_status = row.confirm_status
    //     }
    //     if ((row.employ_status || 0) > (group.employ_status || 0)) {
    //       group.employ_status = row.employ_status
    //     }
    //     // 意向/说明/备注：取非空值
    //     if (!group.intention && row.intention) {
    //       group.intention = row.intention
    //     }
    //     group.intention_note = group.intention_note || row.intention_note
    //     group.note = group.note || row.note
    //   })
    //   return Array.from(map.values())
    // },
    async handleVoid(row) {
      // "status": 2 //1:进行中 2:已完结 3:已作废
      const statusData = {
        ids: row.ids && row.ids.length ? row.ids : [row.id],
        project_id: this.projectId
      }
      const id = await this.$api.cancelApply(statusData)
      if (id) {
        this.$notify.success('取消报名成功')
        this.$emit('refresh')

      }
    }

  },
  mounted() {
    this.getInfo()
  }
}
</script>

<style scoped>
.enrolled-wrap {
  padding: 16px 18px 18px;
  border-radius: 8px;
  /* 固定最小宽度：屏幕缩小到该宽度以下时横向滚动，不再压缩各列 */
  overflow-x: auto;
}

.enrolled-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* 正常宽度按 fr 弹性撑满不压缩；仅当可用宽度不足 1000px 时固定 1000px 横向滚动，保持列宽不变 */
  min-width: 1000px;
}

.detail-head,
.enrolled-row {
  display: grid;
  grid-template-columns: 30px minmax(92px, 0.95fr) minmax(64px, 0.7fr) minmax(60px, 0.72fr) minmax(60px, 0.72fr) minmax(126px, 1.1fr) 84px 84px;
  column-gap: 18px;
  align-items: center;
}

.detail-head {
  min-height: 36px;
  padding: 0 18px;
  color: #8793a8;
  font-size: 12px;
}

.enrolled-row {
  min-height: 60px;
  padding: 10px 18px;
  border: 1px solid #e4e9f2;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(16, 24, 40, 0.05);
}

.row-index {
  color: #8793a8;
  font-size: 13px;
}

.row-name {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.assign-tag {
  flex: 0 0 auto;
}

.row-group-tag {
  flex: 0 0 auto;
  height: 20px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  background: #eef2ff;
  color: #5b6cff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.row-name-text {
  color: #0f172a;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row-text {
  color: #475569;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row-status,
.row-action {
  display: flex;
  align-items: center;
}

.row-action ::v-deep .el-button--mini {
  min-width: 70px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: #5b6cff;
  box-shadow: 0 6px 14px rgba(91, 108, 255, 0.24);
}

.row-action ::v-deep .el-button--mini.is-disabled,
.row-action ::v-deep .el-button--mini.is-disabled:hover {
  border-color: #cdd5e4;
  background: #cdd5e4;
  box-shadow: none;
}

.platform-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.platform-chip {
  height: 32px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #e3e8f2;
  border-radius: 10px;
  background: #fff;
  color: #1f2937;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.platform-chip.is-selected {
  border-color: #b6e6c0;
  background: #eefaf1;
  color: #1f7a46;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(73, 181, 100, 0.12);
}

.platform-check {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex: 0 0 auto;
  background: #ff4f8b;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

.row-intention {
  display: flex;
  align-items: center;
  min-width: 0;
}

.intention-pill {
  min-width: 48px;
  height: 28px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #e1e7f0;
  background: #fff;
  color: #5a667b;
  font-size: 12px;
  line-height: 28px;
  white-space: nowrap;
}

.status-pill {
  height: 24px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.status-pill .status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex: 0 0 auto;
}

/* 已合作：成功绿（对称报名表已报态） */
.status-pill.is-applied {
  border: 1px solid #b7e3c4;
  background: #effaf3;
  color: #1e7a46;
}

.status-pill.is-applied .status-dot {
  background: #22a55c;
}

/* 已初选：暖色（对称报名表待报态） */
.status-pill.is-pending {
  border: 1px solid #f0d9a6;
  background: #fdf6e3;
  color: #a16207;
}

.status-pill.is-pending .status-dot {
  background: #d97706;
}

/* 已报名：浅绿色（与已合作绿色保持可辨差异） */
.status-pill.is-default {
  border: 1px solid #c3e6d3;
  background: #e6f7ee;
  color: #1e7a46;
}

.status-pill.is-default .status-dot {
  background: #2f9e62;
}

.empty-text {
  padding: 28px 0;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

/* 平台 chip：可点击查看关联刊例 */
.platform-chip.is-link {
  cursor: pointer;
  transition: transform .15s ease, border-color .15s ease, box-shadow .15s ease;
}

.platform-chip.is-link:hover {
  transform: translateY(-1px);
  border-color: #9ed7aa;
  box-shadow: 0 3px 10px rgba(73, 181, 100, 0.18);
}

/* 关联刊例提报记录弹窗 */
.plc-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 60vh;
  overflow-y: auto;
}

.plc-card {
  border: 1px solid #e6e9f0;
  border-radius: 8px;
  background: #fafbfc;
  overflow: hidden;
}

.plc-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #eef2f8;
  font-size: 13px;
}

.plc-index {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #5b6cff;
  color: #fff;
  font-size: 12px;
  flex: 0 0 auto;
}

.plc-name {
  font-weight: 700;
  color: #0f172a;
}

.plc-account {
  color: #475569;
}

.plc-time {
  margin-left: auto;
  color: #909399;
  font-size: 12px;
}

.plc-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
}

.plc-quote,
.plc-field {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  line-height: 1.5;
}

.plc-quote {
  flex-direction: column;
  gap: 2px;
}

.plc-label {
  flex: 0 0 auto;
  color: #8793a8;
  font-size: 12px;
}

.plc-quote-line {
  color: #0f172a;
  font-size: 13px;
  word-break: break-all;
}

.plc-value {
  color: #334155;
  font-size: 13px;
  word-break: break-all;
}

.plc-value.is-link-text {
  color: #5b6cff;
  text-decoration: underline;
}

/* 刊例匹配校验状态条 */
.plc-match-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  margin-bottom: 12px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.4;
}

.plc-match-status.is-ok {
  background: #eefaf1;
  color: #1e7a46;
  border: 1px solid #b7e3c4;
}

.plc-match-status.is-warn {
  background: #fdf6e3;
  color: #a16207;
  border: 1px solid #f0d9a6;
}

.plc-match-status.is-muted {
  background: #f2f4f8;
  color: #64748b;
  border: 1px solid #e6e9f0;
}

.plc-fix-btn {
  margin-left: auto;
}

.plc-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.plc-toolbar-hint {
  color: #8793a8;
  font-size: 12px;
}

.manual-search {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.manual-input {
  width: 280px;
}

.manual-hint {
  color: #8793a8;
  font-size: 12px;
}

.manual-empty {
  padding: 24px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.manual-footer {
  display: flex;
  align-items: center;
}

.manual-count {
  margin-right: auto;
  color: #475569;
  font-size: 13px;
}


</style>
